import { App, DirectiveBinding, nextTick } from 'vue'

const placeholderMarquee = {
	mounted(el: HTMLElement, binding: DirectiveBinding<number | undefined>) {
		nextTick(() => {
			const input =
				el instanceof HTMLInputElement ? el : el.querySelector('input')
			if (!input) return

			const text = input.placeholder
			let index = 0
			const speed = binding.value || 1000 // Default slow scrolling (1.5s per move)

			let animationFrame: NodeJS.Timeout | null = null

			const getInputPadding = (input: HTMLElement) => {
				const computedStyle = getComputedStyle(input)
				const paddingLeft = parseFloat(computedStyle.paddingLeft)
				const paddingRight = parseFloat(computedStyle.paddingRight)
				return paddingLeft + paddingRight
			}

			// Function to check if placeholder is wider than input
			const shouldMarquee = () => {
				const testSpan = document.createElement('span')
				testSpan.style.position = 'absolute'
				testSpan.style.visibility = 'hidden'
				testSpan.style.whiteSpace = 'nowrap'
				testSpan.style.font = getComputedStyle(input).font
				testSpan.textContent = text
				document.body.appendChild(testSpan)

				const isTooLong =
					testSpan.offsetWidth + getInputPadding(input) > input.clientWidth
				document.body.removeChild(testSpan)

				return isTooLong
			}

			const animatePlaceholder = () => {
				if (shouldMarquee()) {
					// Only animate if the text is longer
					input.placeholder =
						text.substring(index) + ' ' + text.substring(0, index)
					index = (index + 1) % text.length
					animationFrame = setTimeout(
						() => requestAnimationFrame(animatePlaceholder),
						speed
					)
				}
			}

			// Start animation if needed
			animatePlaceholder()

			// Pause on focus
			input.addEventListener('focus', () => {
				if (animationFrame) clearTimeout(animationFrame)
				input.placeholder = text // Reset to original
				index = 0 // Reset index
			})

			// Resume on blur (if empty)
			input.addEventListener('blur', () => {
				if (!input.value) animatePlaceholder()
			})

			// Store reference for cleanup
			;(input as any).__placeholderMarquee__ = () => {
				if (animationFrame) clearTimeout(animationFrame)
			}
		})
	},
	beforeUnmount(el: HTMLElement) {
		const input =
			el instanceof HTMLInputElement ? el : el.querySelector('input')
		if (input && (input as any).__placeholderMarquee__) {
			;(input as any).__placeholderMarquee__()
		}
	}
}

export default {
	install(app: App) {
		app.directive('placeholder-marquee', placeholderMarquee)
	}
}
